import { useCallback } from 'react';

import { useMarkInboxEntryAsViewedService } from '../../services/inboxEntries.service';
import { useUnreadStore } from '../../store';

export const useMarkInboxEntryAsViewed = () => {
  const { markInboxEntryAsViewed: markInboxEntryAsViewedService } =
    useMarkInboxEntryAsViewedService();
  const { markAsRead, addUnread } = useUnreadStore();

  const markAsViewed = useCallback(
    async (inboxEntryId: string, taskGroupId: string) => {
      try {
        markAsRead(inboxEntryId, taskGroupId); // optimistic
        await markInboxEntryAsViewedService(inboxEntryId);
      } catch (error) {
        addUnread(inboxEntryId, taskGroupId); // rollback
        throw error;
      }
    },
    [markAsRead, addUnread, markInboxEntryAsViewedService],
  );

  return {
    markAsViewed,
  };
};
